import { useFormik } from "formik";
import * as Yup from "yup";
import Button from "../../../ui/utils/Button";
import InputField from "../../../ui/form/InputField";
import Alert from "../../../ui/utils/Alert";
import apiRequest from "../../../../utils/admin/apiRequest";
import usePost from "../../../../hooks/api/usePost";
import useFetch from "../../../../hooks/api/useFetch";
import SelectField from "../../../ui/form/SelectField";
import { useEffect } from "react";

const CreateCity = ({ closeModal, callback }) => {
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.createCity);

  const { data: countryData } = useFetch({
    apiMethod: apiRequest.getCountry,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
  });

  const {
    data: stateData,
    refetch: fetchStates,
    setBlankResponse,
  } = useFetch({
    apiMethod: apiRequest.getStateByCountryId,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
    autoFetch: false,
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      stateId: "",
      countryId: "",
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      countryId: Yup.string().required("Country is required"),
      stateId: Yup.string().required("State is required"),
    }),

    onSubmit: async (values, { resetForm }) => {
      const response = await post({ data: { body: values } });
      if (response.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });

  useEffect(() => {
    const countryId = formik.values.countryId;

    if (countryId) {
      fetchStates({ countryId });
      formik.setFieldValue("stateId", "");
    } else {
      setBlankResponse(); 
    }
  }, [formik.values.countryId]);

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Create City</h2>
      <div className="border-b" />
      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}

        <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-2">

          <SelectField
            name="countryId"
            label="Country"
            placeholder="Select Country"
            value={formik.values.countryId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.countryId}
            error={formik.touched.countryId && formik.errors.countryId}
            options={countryData?.countries?.map((item) => ({
              value: item._id,
              label: item.name,
            }))}
          />

          <SelectField
            name="stateId"
            label="State"
            placeholder="Select State"
            value={formik.values.stateId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.stateId}
            error={formik.touched.stateId && formik.errors.stateId}
            options={stateData?.states?.map((item) => ({
              value: item._id,
              label: item.name,
            }))}
          />

          <InputField
            name="name"
            label="City Name"
            placeholder="Enter city name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && formik.errors.name}
            serverError={serverErrors?.name}
          />
        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Creating..."
            isLoading={loading}
          >
            Create
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateCity;
